export default __webpack_public_path__ + "static/media/seminar (4).31f4398a.JPG";